import React from "react";
import Spinner from "./Spinner";

const SpinnerOverlay: React.FC<{ text?: string }> = ({ text }) => (
  <div
    style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.01)", // 거의 투명하지만 배경색을 지정하여 클릭 이벤트를 잡도록 함
      zIndex: 99999,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "auto" // 명시적으로 포인터 이벤트 활성화
    }}
  >
    <Spinner size={60} />
    {text && (
      <div style={{ color: "#000", marginTop: 16, fontSize: 18, fontWeight: 500 }}>
        {text}
      </div>
    )}
  </div>
);

export default SpinnerOverlay; 